import React from 'react';
import styled from 'styled-components';
import Button from '../input/Button';
import Spacer from '../Spacer';
import Card from './Card';

const BackgroundHider = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #00000014;
  z-index: 100;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const Title = styled.div`
  font-size: 26px;
  font-weight: 600;
  padding-bottom: 28px;
`;

type Props = {
  onSave?: () => void;
  onCancel?: () => void;
  children?: React.ReactNode;
  title?: string;
  disabled?: boolean;
};

const Popup = ({ onSave, onCancel, children, disabled, title = '' }: Props) => {
  return (
    <>
      <BackgroundHider
        onClick={(evt) => {
          evt.stopPropagation();
          if (onCancel) {
            onCancel();
          }
        }}
      />
      <Card>
        <Title>{title}</Title>
        {children}
        <Spacer vertical spacing={3} />
        <Buttons>
          {onCancel && (
            <Button onClick={onCancel} background={'#D3D3D3'} color={'white'}>
              Cancel
            </Button>
          )}
          <Spacer horizontal spacing={2} />
          {onSave && (
            <Button onClick={onSave} color={'white'} disabled={disabled}>
              Save
            </Button>
          )}
        </Buttons>
      </Card>
    </>
  );
};

export default Popup;
